import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from "rxjs";
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders ,HttpEvent, HttpRequest} from '@angular/common/http';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../components/dialogs/message-dialog/message-dialog.component';
import { OrderDetailsNew } from '../models/order.models';
import { HttpParams } from '@angular/common/http';

import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root',
})

export class DataService {
    baseUrl: string = environment.apiUrl;
  selectedPerson: any ;selectedOptions: any;
    http: any;


    postFileWithProgress(url: string, file: File): Observable<HttpEvent<any>> {
        const form = new FormData();
  form.append('file', file);

  
  return this.httpClient.post(this.baseUrl + url, form, {
    reportProgress: true,
    observe: 'events',    
       
        });
    
       
      }

    progressBarActive: boolean = false;
    progressBarActiveForSlider: boolean = false;
    pageTitle: string = '';
    
    displayImageBytes: string = '';
    isActive: boolean = false;
    isAvailable: boolean = false;
    isOauthUser: boolean = false;
    role: string = '';
    userId: string = '';
    initials: string = '';
    cartCount: number = 0;
    emailId: string = '';
    firstName: string = '';
    lastName: string = '';
    selectedTaskFilters: string[] = [];
 

    constructor(private httpClient: HttpClient, private location: Location, private dialog: MatDialog, @Inject(PLATFORM_ID) private platformId: Object) {}

    private getSessionItem(key: string): string {
        if (isPlatformBrowser(this.platformId)) {
            return sessionStorage.getItem(key) ?? '';
        }
        return '';
    }

    updateCartCount(){
        this.get('/tasks/pending-payment').subscribe({
          next: (response: any[]) => {
            this.cartCount = response.length;
          },
          error: (err) => {
            this.handleError(err, 'Failed to get Sub Types information, Please try again.').subscribe(result => this.location.back());
          }
        });
    }

    refreshState(){
        // Guard prevents repeated sessionStorage reads on every call; properties are populated once per session
        if(!this.userId){
            // this.role = sessionStorage.getItem('role') ?? '';
            this.role = this.getSessionItem('role');
            this.emailId = sessionStorage.getItem('emailId') ?? '';
            this.firstName = sessionStorage.getItem('firstName') ?? '';
            this.lastName = sessionStorage.getItem('lastName') ?? '';
            this.userId = sessionStorage.getItem('userId') ?? '';
            this.initials = sessionStorage.getItem('initials') ?? '';
            this.isOauthUser = sessionStorage.getItem('isOauthUser') === 'true';
            this.isActive = sessionStorage.getItem('isActive') === 'true';
            this.isAvailable = sessionStorage.getItem('isAvailable') === 'true';
            this.displayImageBytes = sessionStorage.getItem('displayImageBytes') ?? '';
        }
        return this.userId.length > 0;
    }

    isLoggedIn(){
        // this.role = sessionStorage.getItem('role') ?? '';
        this.role = this.getSessionItem('role');
        this.userId = sessionStorage.getItem('userId') ?? '';
        this.emailId = sessionStorage.getItem('emailId') ?? '';
        this.firstName = sessionStorage.getItem('firstName') ?? '';
        this.lastName = sessionStorage.getItem('lastName') ?? '';
        this.initials = sessionStorage.getItem('initials') ?? '';
        this.isActive = sessionStorage.getItem('isActive') === 'true';
        this.isAvailable = sessionStorage.getItem('isAvailable') === 'true';
        this.isOauthUser = sessionStorage.getItem('isOauthUser') === 'true';
        this.displayImageBytes = sessionStorage.getItem('displayImageBytes') ?? '';
        return this.token().length > 0;
    }

    updateTitle(title: string) {
        // setTimeout(0) defers the assignment past the current change-detection cycle, preventing ExpressionChangedAfterItHasBeenChecked errors
        setTimeout(() => this.pageTitle = title, 0);
    }

    updateProgressBarSubject(progressBarActive: boolean) {
        // Same deferred-update pattern as updateTitle — avoids CD errors when called from lifecycle hooks
        setTimeout(() => this.progressBarActive = progressBarActive, 0);
    }

    updateProgressBarSubjectForSlider(progressBarActiveForSlider: boolean) {
        setTimeout(() => this.progressBarActiveForSlider = progressBarActiveForSlider, 0);
    }

    saveUserDetails(response: any) {
        // Basic auth header format: base64(userId:token) — must match what the interceptor decodes
        sessionStorage.setItem('token', btoa(response.userId+':'+response.token));
        sessionStorage.setItem('role', response.role.replace('ROLE_', ''));
        sessionStorage.setItem('emailId', response.emailId);
        sessionStorage.setItem('firstName', response.firstName);
        sessionStorage.setItem('lastName', response.lastName);
        sessionStorage.setItem('userId', response.userId);
        sessionStorage.setItem('isOauthUser', response.isOauthUser);
        sessionStorage.setItem('isActive', response.isActive);
        sessionStorage.setItem('isAvailable', response.isAvailable);
        sessionStorage.setItem('displayImageBytes', response.displayImageBytes ? response.displayImageBytes : '');
        if(response.firstName && response.lastName){
            sessionStorage.setItem('initials', response.firstName[0].toUpperCase() + response.lastName[0].toUpperCase());
        }else{
            sessionStorage.setItem('initials', response.userId[0].toUpperCase());
        }
        this.refreshState();
    }

    token() {
        return sessionStorage.getItem('token') ?? '';
    }

    clearUserDetails() {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('role');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('initials');
        this.refreshState();
    }

    getDataAsList(path: string): Observable<any[]> {
        return this.httpClient.get<any[]>(environment.apiUrl + path);
    }
    getDataDas(path: string, params?: any): Observable<any[]> {
        return this.httpClient.get<any[]>(environment.apiUrl + path, { params });
      }

      postDataForeditUser(path: string, content: any): Observable<any> {
       
        return this.httpClient.post<any>(environment.apiUrl + path, content);   
    }
      
      

    get(path: string, options?: any): Observable<any> {
        var optionsToSend = options ? options : {};
        return this.httpClient.get<any>(environment.apiUrl + path, optionsToSend);
    }
    
    getStaticFile<T>(path: string): Observable<T> {
        return this.httpClient.get<T>(path);
    }

    post(path: string, content: any): Observable<any> {
        return this.httpClient.post<any>(environment.apiUrl + path, content);
    }

    put(path: string, content: any): Observable<any> {
        return this.httpClient.put<any>(environment.apiUrl + path, content);
    }

    delete(path: string): Observable<any> {
        return this.httpClient.delete<any>(environment.apiUrl + path);
    }

    postFile(path: string, file: File, body?: any): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        if (body) {
            Object.keys(body).forEach(key => {
                formData.append(key, body[key]);
            });
        }
        return this.httpClient.post(environment.apiUrl + path, formData, {
            headers: new HttpHeaders({ 'X-Digital-FileName': file.name.replace(/[^a-zA-Z0-9.]/g, '_') })
        });
    }

    postMultiPartData(path: string, formData: FormData, headers?: HttpHeaders): Observable<any> {
        const options = headers ? { headers } : {};
        return this.httpClient.post(environment.apiUrl + path, formData, options);
    }

    combineToothNumbers(input: number[]): string {
        if (input.length === 0) return '';
    
        const sorted = input.sort((a, b) => a - b);
        const ranges: string[] = [];
        let start = sorted[0];
      
        for (let i = 1; i <= sorted.length; i++) {
          if (i === sorted.length || sorted[i] !== sorted[i - 1] + 1) {
            const end = sorted[i - 1];
            ranges.push(start === end ? `${start}` : `${start} - ${end}`);
            start = sorted[i];
          }
        }
      
        return ranges.join(', ');
      }
      
    invertToothNumbers(input: string): number[] {
        const result: number[] = [];
        const ranges = input.split(',').map(range => range.trim());

        ranges.forEach(range => {
            const [start, end] = range.split('-').map(Number);
            if (end !== undefined) {
                for (let i = start; i <= end; i++) {
                    result.push(i);
                }
            } else {
                result.push(start);
            }
        });

        return result;
    }

    handleError(error: any, errorMessage: string): Observable<any> {
        if (error.status === 401) {
            this.clearUserDetails();
            this.openMessageDialog('Error', 'Session expired, please login again.').subscribe(() => window.location.href = '#/login');
            return EMPTY;
        }else{
            return this.openMessageDialog('Error', errorMessage);
        }
    }

    openMessageDialog(header: string, body: string): Observable<any> {
        this.updateProgressBarSubject(false);
        const dialogRef = this.dialog.open(MessageDialogComponent, {
            data: { header: header, content: body }
        });
        return dialogRef.afterClosed();
    }

    openMessageDialogWithSize(header: string, body: string, width: string, height: string) {
        this.updateProgressBarSubject(false);
        const dialogRef = this.dialog.open(MessageDialogComponent, {
            width: width, height: height,
            data: { header: header, content: body }
        });
        return dialogRef.afterClosed();
    }

    checkTwoSetIntersect(array1: number[], array2: number[]): boolean {
        return array1.some(tooth => array2.includes(tooth));
    }

    anteriorTeeth: number[] = [
        13, 12, 11, 21, 22, 23,
        43, 42, 41, 31, 32, 33
    ];

    anteriorTeeth_1: number[] = [
                13, 12, 11, 21, 22, 23,
        45, 44, 43, 42, 41, 31, 32, 33, 34, 35
    ];

    isAnteriorTeeth(teeth: number[]): boolean {
        return teeth.every(tooth => this.anteriorTeeth.includes(tooth));
    }

    groupByAnteriorAndPosterior_1(teeth: number[]): { anterior: number[], posterior: number[] } {
        const anterior: number[] = [];
        const posterior: number[] = [];
        teeth.forEach(tooth => {
            if (this.anteriorTeeth_1.includes(tooth)) {
                anterior.push(tooth);
            } else {
                posterior.push(tooth);
            }
        });
        return { anterior, posterior };
    }

    groupByAnteriorAndPosterior(teeth: number[]): { anterior: number[], posterior: number[] } {
        const anterior: number[] = [];
        const posterior: number[] = [];
        teeth.forEach(tooth => {
            if (this.anteriorTeeth.includes(tooth)) {
                anterior.push(tooth);
            } else {
                posterior.push(tooth);
            }
        });
        return { anterior, posterior };
    }

    teethOrder: number[] = [
        18, 17, 16, 15, 14,   13, 12, 11, 21, 22, 23,   24, 25, 26, 27, 28,
        48, 47, 46, 45, 44,   43, 42, 41, 31, 32, 33,   34, 35, 36, 37, 38
    ];

    rearrangedTeethOrder(teeth: number[]): string {
        return this.teethOrder.filter(tooth => teeth.includes(tooth)).join(', ');
    }

    rearrangedTeethOrderByOrderDetails(orderDetailsNew: OrderDetailsNew){
        var teeth: number[] = orderDetailsNew.toothData.map(tooth => tooth.teeth).flat();
        return this.teethOrder.filter(tooth => teeth.includes(tooth)).join(', ');
    }

    getDataAsText(url: string): Observable<string> {
        return this.httpClient.get<string>(environment.apiUrl + url, {
          responseType: 'text' as 'json'
        });
      }
      
      
    anteriorBridgedTeeth(orderDetailsNew: OrderDetailsNew, bridgedTeeth: number[]): number[] {
        var filteredBridgedTeeth = bridgedTeeth.filter(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Anatomy'));
        if (
            filteredBridgedTeeth.some(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Anatomy'))
            &&
            this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior.length >= this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior.length
        ) {
            return [...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior, ...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior];
        } else {
            return [];
        }
    }

    posteriorBridgedTeeth(orderDetailsNew: OrderDetailsNew, bridgedTeeth: number[]): number[] {
        var filteredBridgedTeeth = bridgedTeeth.filter(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Anatomy'));
        if (
            filteredBridgedTeeth.some(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Anatomy'))
            &&
            this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior.length > this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior.length
        ) {
            return [...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior, ...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior];
        } else {
            return [];
        }
    }
      
    anteriorBridgedTeethFrame(orderDetailsNew: OrderDetailsNew, bridgedTeeth: number[]): number[]{
        var filteredBridgedTeeth = bridgedTeeth.filter(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame'));
        if (
            filteredBridgedTeeth.some(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame'))
            &&
            this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior.length >= this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior.length
        ) {
            return [...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior, ...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior];
        } else {
            return [];
        }
    }

    posteriorBridgedTeethFrame(orderDetailsNew: OrderDetailsNew, bridgedTeeth: number[]): number[] {
        var filteredBridgedTeeth = bridgedTeeth.filter(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame'));
        if (
            filteredBridgedTeeth.some(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame'))
            &&
            this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior.length > this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior.length
        ) {
            return [...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior, ...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior];
        } else {
            return [];
        }
    }


    anteriorTeethForFrame_1(orderDetailsNew: OrderDetailsNew): number[] {
        var bridgedTeeth = orderDetailsNew.bridges.map(b => b.bridgedTeeth).flat()
        return this.groupByAnteriorAndPosterior_1(orderDetailsNew.toothData.filter(data => data.type == 'Frame' && bridgedTeeth.indexOf(data.teeth) == -1).map(data => data.teeth)).anterior;
    }

    posteriorTeethForFrame_1(orderDetailsNew: OrderDetailsNew): number[] {
        var bridgedTeeth = orderDetailsNew.bridges.map(b => b.bridgedTeeth).flat()
        return this.groupByAnteriorAndPosterior_1(orderDetailsNew.toothData.filter(data => data.type == 'Frame' && bridgedTeeth.indexOf(data.teeth) == -1).map(data => data.teeth)).posterior;
    }

    anteriorPonticTeeth(orderDetailsNew: OrderDetailsNew): number[] {
        return this.groupByAnteriorAndPosterior(orderDetailsNew.toothData.filter(data => data.subType == 'Pontic' && data.type == 'Anatomy').map(data => data.teeth)).anterior;
    }

    posteriorPonticTeeth(orderDetailsNew: OrderDetailsNew): number[] {
        return this.groupByAnteriorAndPosterior(orderDetailsNew.toothData.filter(data => data.subType == 'Pontic' && data.type == 'Anatomy').map(data => data.teeth)).posterior;
    }

    anteriorTeethForAnatomy(orderDetailsNew: OrderDetailsNew): number[]{
        return this.groupByAnteriorAndPosterior(orderDetailsNew.toothData.filter(data => data.type == 'Anatomy').map(data => data.teeth)).anterior;
    }

    posteriorTeethForAnatomy(orderDetailsNew: OrderDetailsNew): number[]{
        return this.groupByAnteriorAndPosterior(orderDetailsNew.toothData.filter(data => data.type == 'Anatomy').map(data => data.teeth)).posterior;
    }

    anteriorTeethForCrownOrPonticFrame(orderDetailsNew: OrderDetailsNew, bridgedTeeth: number[]): number[]{
        var filteredBridgedTeeth = bridgedTeeth.filter(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame' && (data.subType == 'Crown' || data.subType == 'Pontic' || data.subType == 'Inlay/Onlay')));
        if (
            filteredBridgedTeeth.some(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame' && (data.subType == 'Crown' || data.subType == 'Pontic' || data.subType == 'Inlay/Onlay')))
            &&
            this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior.length >= this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior.length
        ) {
            return [...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior, ...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior];
        } else {
            return [];
        }
    }

    posteriorTeethForCrownOrPonticFrame(orderDetailsNew: OrderDetailsNew, bridgedTeeth: number[]): number[]{
        var filteredBridgedTeeth = bridgedTeeth.filter(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame' && (data.subType == 'Crown' || data.subType == 'Pontic' || data.subType == 'Inlay/Onlay')));
        if (
            filteredBridgedTeeth.some(teeth => orderDetailsNew.toothData.some(data => data.teeth == teeth && data.type == 'Frame' && (data.subType == 'Crown' || data.subType == 'Pontic' || data.subType == 'Inlay/Onlay')))
            &&
            this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior.length > this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior.length
        ) {
            return [...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).anterior, ...this.groupByAnteriorAndPosterior(filteredBridgedTeeth).posterior];
        } else {
            return [];
        }
    }

    anteriorTeethForCrownOrPontic(orderDetailsNew: OrderDetailsNew): number[] {
        return this.groupByAnteriorAndPosterior(orderDetailsNew.toothData.filter(data => (data.subType == 'Crown' || data.subType == 'Pontic') && data.type == 'Anatomy').map(data => data.teeth)).anterior;
    }

    posteriorTeethForCrownOrPontic(orderDetailsNew: OrderDetailsNew): number[] {
        return this.groupByAnteriorAndPosterior(orderDetailsNew.toothData.filter(data => (data.subType == 'Crown' || data.subType == 'Pontic') && data.type == 'Anatomy').map(data => data.teeth)).posterior;
    }
  private subject = new BehaviorSubject<string | null>(null);
  trigger$ = this.subject.asObservable();

  trigger(status: string) {
    this.subject.next(status);
  }

setSelectedTaskFilters(filters: string[]) {
  this.selectedTaskFilters = filters;
}

getSelectedTaskFilters(): string[] {
  return this.selectedTaskFilters;
}
downloadFile(url: string) {
  return this.http.get(url, {
    responseType: 'blob'
  });
}

}